import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContextProvider'
import { Layout } from './components/layout/Layout'
import { EventPage } from './pages/EventPage'
import { SupportPage } from './pages/SupportPage'
import { PaymentSetupRedirect } from './pages/PaymentSetupRedirect'
import { PaymentSetupComplete } from './pages/PaymentSetupComplete'
import { PaymentSetupError } from './pages/PaymentSetupError'
import { useTheme } from './hooks/useTheme'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

function App() {
  useTheme()

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/support" element={<SupportPage />} />
              {/* Payment-setup routes (issue #206) must sit ABOVE the
                  /:eventId/:inviteId? catch route so they don't fall through
                  to EventPage's "event not found" dead-end. */}
              <Route path="/payment-setup" element={<PaymentSetupRedirect />} />
              <Route path="/payment-setup/complete" element={<PaymentSetupComplete />} />
              {/* Where every payment-setup failure lands (issue #209) — the edge
                  function 302s here with ?state=<recoverable|non_recoverable>&eid=,
                  instead of dead-ending on plain text on the functions domain. */}
              <Route path="/payment-setup/error" element={<PaymentSetupError />} />
              <Route path="/" element={<EventPage />} />
              <Route path="/:eventId/:inviteId?" element={<EventPage />} />
              <Route
                path="/event/:eventId/:inviteId?"
                element={<EventPage />}
              />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App
